import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id A566BA98-D35A-443F-AD31-0D31EF0B85EC
 * name calendar-today
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-today.svg
 * tags
 * - Date / Time 
 */
export const CalendarTodayIcon = createSvgIcon(<><path d="M7,10H12V15H7M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z" /></>, 'CalendarTodayIcon');
export default CalendarTodayIcon